export default __webpack_public_path__ + "static/media/search-icon.7b66862c.svg";